import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const VersionInput: FunctionComponent<BasicInfoComponentProps> = (
  props: PropsWithChildren<BasicInfoComponentProps>
) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl data-testid="version-input-form-control">
      <BaseFormInputField
        id="version"
        label="Version"
        name="version"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.version && touched.version}
        helperText={!!errors.version && touched.version && errors.version}
        value={values.version ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
